import MoreNewsCardBlock
from '../components/News/ArticleLayout/MoreNews/MoreNewsCardBlock';
import MoreNewsListBlock
from '../components/News/ArticleLayout/MoreNews/MoreNewsListBlock';

const getMoreNewsRows = (locale) => ([
  'nl-NL',
  'fr-FR',
].includes(locale)
  ? [MoreNewsCardBlock, MoreNewsCardBlock, MoreNewsCardBlock, MoreNewsCardBlock]
  : [MoreNewsCardBlock, MoreNewsListBlock]
);

export default getMoreNewsRows;
